import { __exports as tokenGeneratorInstance } from './_virtual-tokenGeneratorInstance.js';
import { __require as requireInteropRequireDefault } from './node_modules-@babel-runtime-helpers-interopRequireDefault.js';
import { __require as requireTokenGeneratorMap } from './vp-js-token-engine-build-tokenGenerators-TokenGeneratorMap.js';

var hasRequiredTokenGeneratorInstance;

function requireTokenGeneratorInstance () {
	if (hasRequiredTokenGeneratorInstance) return tokenGeneratorInstance;
	hasRequiredTokenGeneratorInstance = 1;

	var _interopRequireDefault = requireInteropRequireDefault();
	Object.defineProperty(tokenGeneratorInstance, "__esModule", {
	  value: true
	});
	tokenGeneratorInstance.tokenGeneratorMapInstance = void 0;
	var _TokenGeneratorMap = _interopRequireDefault(requireTokenGeneratorMap());
	tokenGeneratorInstance.tokenGeneratorMapInstance = new _TokenGeneratorMap.default();
	
	return tokenGeneratorInstance;
}

export { requireTokenGeneratorInstance as __require };
//# sourceMappingURL=vp-js-token-engine-build-tokenGenerators-infrastructure-tokenGeneratorInstance.js.map
